import { LOCALE_TYPE } from 'src/types/locale';

export const convertLocaleForZendesk = (locale: LOCALE_TYPE) => {
  switch (locale) {
    case LOCALE_TYPE.TW:
      return 'zh-tw';
    case LOCALE_TYPE.HK:
      return 'zh-hk';
    case LOCALE_TYPE.CN:
      return 'zh-cn';
    case LOCALE_TYPE.EN:
      return 'en-us';
    case LOCALE_TYPE.JA:
      return 'ja';

    default:
      return 'en-us';
  }
};
